import React from "react";
import ToolBoxList from "../components/ToolBoxList";
import ToolBoxPopOver from "../components/ToolBoxPopOver";
import FaUser from "react-icons/lib/fa/user";

class ToolBoxListContainer extends React.Component {
  constructor(props) {
    super(props);

    this.itemListOnClickHandler = this.itemListOnClickHandler.bind(this);
    this.popOverOnClickHandler = this.popOverOnClickHandler.bind(this);
    this.windowResizeHandler = this.windowResizeHandler.bind(this);
    this.windowClickHandler = this.windowClickHandler.bind(this);
    this.windowKeyDownHandler = this.windowKeyDownHandler.bind(this);
    this.deactivatePopOver = this.deactivatePopOver.bind(this);

    this.state = {
      items: [
        {
          id: 1,
          label: "Matlab",
            description: `A fourth-generation <a target="_blank" href="https://it.mathworks.com/products/matlab.html">programming language</a>
            massively used by scientists and engineers.`,
          comment: `I literally use it everyday and I love it`
        },
        {
          id: 2,
          label: "Tcl/tk",
          description: `<a target="_blank" href="https://www.tcl.tk/">The Tool Command Language</a> is a very powerful but easy to learn dynamic programming language, suitable for a wide range of uses.`,
          comment: `I use it because this is the basis for the structural analysis software OpenSees`,
        },
        {
          id: 18,
          label: "Latex",
          description: `It’s a high-quality <a target="_blank" href="https://www.latex-project.org/">typesetting system</a> used to produce professional text documents.`,
          comment: `I use it to prepare scientific papers. It allows to obtain excellent results.`
        },
        {
          id: 3,
          label: "Ruaumoko",
          description: `It’s a super-efficient <a href="https://www.researchgate.net/publication/313476413_Ruaumoko_Theory_Manual" target="_blank">structural analysis program</a> by prof. Athol Carr, named after the Maori god of earthquakes and volcanoes.`,
          comment: `It’s my favourite program to model RC structures subjected to earthquakes`
        },
        {
          id: 4,
          label: "OpenSees",
            description: `The <a href="http://opensees.berkeley.edu/" target="_blank">Open System for Earthquake Engineering Simulation</a> is a software framework for simulating the seismic response of structural and geotechnical systems.`,
          comment: `I used it for many models, and I like its flexibility`
        },
        {
          id: 21,
          label: "SAP2000",
            description: `<a href="https://www.csiamerica.com/products/sap2000" target="_blank">The Structural Analysis Program</a> is a famous software used for civil engineering modelling problems.`,
          comment: `Sometimes you need a graphical interface ;)`
        },
        {
          id: 5,
          label: "Seismostruct",
            description: `This is a <a href="http://www.seismosoft.com/seismostruct" target="_blank">Finite Element package</a> capable of predicting the behaviour of space frames under static or dynamic loading.`,
            comment: ``
        },
        {
          id: 6,
          label: "Abaqus",
            description: `It’s a <a href="https://www.ansys.com/" target="_blank">reliable FEM software</a> with many applications fields. In the field of civil engineering, it is usually adopted for detailed analyses`,
          comment: ``
        },
        {
          id: 19,
          label: "Strand7",
            description: `<a href="http://www.strand7.com/" target="_blank">Strand7</a> is a combination of a suite of powerful solvers and a visual environment. It allows to solve a large number of numerical structural problems.`,
          comment: ``
        },
        {
          id: 7,
          label: "AutoCAD",
            description: `Super-famous Computer Aided Drawing software. There is no need for further presentations`,
          comment: ``
        },
        {
          id: 9,
          label: "Revit",
            description: `<a href="https://www.autodesk.it/products/revit-family/overview" target="_blank">BIM software.</a> It allows to organically manage the processes of planning, design, construction and management of buildings and infrastructures`,
            comment: ``
        },
        {
          id: 20,
          label: "SolidWorks",
            description: `It’s an advanced CAD and design <a href="http://www.solidworks.it/sw/products/3d-cad/solidworks-standard.htm" target="_blank">software</a> that allows to parametrically create drawings of 3d objects, including assemblies with moving parts`,
          comment: ``
        },
        {
          id: 10,
          label: "Archicad",
            description: `This is a CAD and BIM <a href="https://www.graphisoft.com/it/soluzioni/">software</a> particularly suitable for buildings.`,
            comment: `I used it many times in team projects at uni`
        },
        {
                 id: 89,
                            label: "Atlantis",
                                        description: `Powerful rendering <a href="https://artlantis.com" target="_blank">software</a> particularly suitable for buildings.`,
                                                    comment: `I used it many times in team projects at uni.`
                                                            },

        {
          id: 11,
          label: "Photoshop",
          description: `Famous software for graphic design.`,
          comment: `Rather than photo-retouching, I use this app for almost every plot and or figure for my scientific production`
        },
        {
          id: 12,
          label: "Illustrator",
            description: `Famous software for vectorial graphic design.`,
            comment: `I particularly like it for flowcharts.`
        },
      ],
      activatedItem: null,
      popOver: {
        isActive: false,
        topPx: "auto",
        bottomPX: "auto",
        leftPx: "auto",
        rightPx: "auto",
        description: "",
        comment: ""
      },
      popOverPosition: null
    };
  }

  componentDidMount() {
    if (typeof window !== "undefined") {
      window.addEventListener("resize", this.windowResizeHandler, false);
      window.addEventListener("click", this.windowClickHandler, false);
      window.addEventListener("keydown", this.windowKeyDownHandler, false);
    }
  }

  componentWillUnmount() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.windowResizeHandler, false);
      window.removeEventListener("click", this.windowClickHandler, false);
      window.removeEventListener("keydown", this.windowKeyDownHandler, false);
    }
  }

  componentWillReceiveProps(nextProps) {
    //
  }

  windowKeyDownHandler(e) {
    if (this.state.activatedItem && e.which == 27) {
      this.deactivatePopOver();
    }
  }

  windowResizeHandler() {
    if (this.state.activatedItem) {
      this.deactivatePopOver();
    }
  }

  windowClickHandler(e) {
    const isValidClickTarget =
      e.target.nodeName === "A" || e.target.nodeName === "BUTTON"
        ? true
        : false;
    if (!isValidClickTarget && this.state.activatedItem) {
      this.deactivatePopOver();
    }
  }

  itemListOnClickHandler(e, id) {
    const anchor = {
      offsetTop: e.target.offsetTop,
      offsetLeft: e.target.offsetLeft,
      offsetWidth: e.target.offsetWidth,
      offsetHeight: e.target.offsetHeight
    };
    /*
      check why the initial shape of the code does'n work in iPhone 4
      it semas as array.find() function is not transpiled corectlyu
      const popOver = this.state.items.find(el => el.id === id);
    */
    const popOver = this.state.items.filter(el => el.id === id)[0];
    this.positionPopOver(anchor, popOver);

    this.setState(() => ({
      activatedItem: id
    }));
  }

  positionPopOver(anchor, popOver) {
    const popWidth = 200;
    const popHeight = 100;
    const body = document.querySelector("body");

    const spaceUnder =
      body.offsetHeight - anchor.offsetTop - anchor.offsetHeight;
    const spaceOnRight =
      body.offsetWidth - anchor.offsetLeft - anchor.offsetWidth;

    const verticalPositionUnder = spaceUnder >= anchor.offsetTop ? true : false;
    const horizontalPositionOnRight =
      spaceOnRight >= anchor.offsetLeft ? true : false;

    const verticalPosition = verticalPositionUnder
      ? anchor.offsetTop
      : anchor.offsetTop - popHeight + anchor.offsetHeight;
    const horizontalPosition = horizontalPositionOnRight
      ? anchor.offsetLeft
      : anchor.offsetLeft - popWidth + anchor.offsetWidth;

    const topPx = verticalPositionUnder
      ? `${anchor.offsetTop + anchor.offsetHeight}px`
      : `auto`;
    const bottomPx = verticalPositionUnder
      ? `auto`
      : `${body.offsetHeight - anchor.offsetTop}px`;
    const leftPx = horizontalPositionOnRight
      ? `${anchor.offsetLeft}px`
      : `auto`;
    const rightPx = horizontalPositionOnRight
      ? `auto`
      : `${body.offsetWidth - anchor.offsetLeft - anchor.offsetWidth}px`;
    const positionUnderModifierClass = "";

    this.setState(() => ({
      popOver: {
        isActive: true,
        topPx: topPx,
        bottomPx: bottomPx,
        leftPx: leftPx,
        rightPx: rightPx,
        modifierClasses: `${positionUnderModifierClass}`,
        description: popOver.description,
        comment: popOver.comment
      },
      popOverPosition: verticalPositionUnder ? "under" : "above"
    }));
  }

  popOverOnClickHandler() {
    this.deactivatePopOver();
  }

  deactivatePopOver() {
    this.setState(() => ({
      popOver: {
        isActive: false
      },
      activatedItem: null,
      popOverPosition: null
    }));
  }

  render() {
    return (
      <div>
        <ToolBoxList
          items={this.state.items}
          activatedItem={this.state.activatedItem}
          itemOnClick={this.itemListOnClickHandler}
          popOverPosition={this.state.popOverPosition}
        />
        {this.state.popOver.isActive && (
          <ToolBoxPopOver
            top={this.state.popOver.topPx}
            bottom={this.state.popOver.bottomPx}
            left={this.state.popOver.leftPx}
            right={this.state.popOver.rightPx}
            modifierClasses={this.state.popOver.modifierClasses}
            description={this.state.popOver.description}
            comment={this.state.popOver.comment}
            onClick={this.popOverOnClickHandler}
          />
        )}
      </div>
    );
  }
}

export default ToolBoxListContainer;



// WEBPACK FOOTER //
// ./src/containers/ToolBoxListContainer.jsx